import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { findVariantImage } from '../transformPreviewLink';
import type { GetPreviewLinkByPetitionIdResponse } from '../types';

import type {
	PetitionPreviewLinkByPetitionQuery,
	PetitionPreviewLinkByPetitionQueryVariables,
} from './getPetitionPreviewLinksByPetition.graphql';
import { PetitionPreviewLinkByPetition } from './getPetitionPreviewLinksByPetition.graphql';

export async function getPreviewLinkByPetitionId(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<GetPreviewLinkByPetitionIdResponse> {
	const { data } = await fetch<PetitionPreviewLinkByPetitionQuery, PetitionPreviewLinkByPetitionQueryVariables>({
		query: PetitionPreviewLinkByPetition,
		variables: { slug },
		rejectOnError: true,
	});

	const imageUrl = findVariantImage(data.petitionBySlugOrId?.previewLinksImagesConnection);
	if (data.getPetitionPreviewLinks.__typename === 'PetitionPreviewLinks' && imageUrl) {
		return {
			totalCount: data.getPetitionPreviewLinks.totalCount,
			items: data.getPetitionPreviewLinks.items.map((item) => ({
				...item,
				imageUrl,
			})),
		};
	}

	return {
		totalCount: 0,
		items: [],
	};
}
